module.exports = __webpack_public_path__ + "img/date-2.e8aff96a.svg";